"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var buildEventTarget = function buildEventTarget(nameParam, valueParam, customTargetProps) {
  var inputEl = document.createElement('INPUT');
  var event = {};
  event.target = inputEl;
  event.currentTarget = inputEl;
  event.target.value = valueParam;
  event.target.name = nameParam;
  if (customTargetProps) {
    customTargetProps.forEach(function (prop) {
      event.target[prop.name] = prop.value;
    });
  }
  return event;
};
var _default = buildEventTarget;
exports.default = _default;